import { uuid4 } from "./uuid4";

const storedDeviceId = localStorage.getItem('device_id');
const deviceId = storedDeviceId ?? uuid4();
if (!storedDeviceId) {
    localStorage.setItem('device_id', deviceId);
}

export default deviceId;